import { FadeUp } from "./Reveal";
import { STATS } from "../data/content";
import { useLang } from "../lib/lang";

export const Stats = () => {
  const { tr } = useLang();
  return (
    <div data-testid="stats-section" className="mt-14">
      <div className="grid grid-cols-2 border-l border-t border-white/10 lg:grid-cols-3">
        {STATS.map((s, i) => (
          <FadeUp key={s.value} delay={i * 0.06} className="group border-b border-r border-white/10 p-5 transition-colors duration-500 hover:bg-[var(--acid)] sm:p-10">
            <div data-testid={`stat-value-${i}`} className="font-display text-4xl font-extrabold tracking-tight transition-colors group-hover:text-[var(--ink)] sm:text-6xl lg:text-7xl">{s.value}</div>
            <p className="mt-3 text-sm text-zinc-400 transition-colors group-hover:text-[var(--ink)] sm:text-base">{tr(s.label)}</p>
          </FadeUp>
        ))}
      </div>
    </div>
  );
};
